<template lang="pug">
.page-content
  h1.title Autenticidade de Documentos
  el-row(:gutter="30")
    el-col(:sm="24", :md="5")
      el-card.card-top.card-steper
        el-steps(:direction="directionClass" :active="activeStep")
          el-step.step(title="Protocolo")
            template(slot="icon")
              i.material-icons.icon find_in_page
          el-step(title="Documento" icon="fa fa-file-text-o")
            template(slot="icon")
              i.material-icons.icon description
    el-col(:sm="24", :md="19")
      el-card.card
        template(slot="header", v-if="!isEmptyDocumento()")
          p.tipo-doc {{ documento.tipoDocumentoAutenticavel.descricao }}
          el-button.btn(type="primary", @click="clear()") Procurar novamente
        div(v-else)
          p.subtitle Informe o número do protocolo do documento
          .input
            el-input(
              placeholder="Número do protocolo",
              v-mask="protocoloMask",
              v-model="protocolo",
              @keyup.enter.native="search()"
            )
              template(slot="suffix")
                i.material-icons(@click="search()") search
        #isEmpty(v-if="isEmpty") Não há registro de documento para o protocolo informado.
        el-row.dados-doc
          router-view
            template(slot="validacao_assinatura")
              .link-download
                font-awesome-icon(icon="link")
                a(href="https://validar.iti.gov.br/" target="_blank") &nbsp Link para validação da assinatura
            template(slot="baixar")
              .link-download
                font-awesome-icon(icon="cloud-download-alt")
                a(@click="downloadDoc()") &nbsp Baixar Documento
</template>
<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      isEmpty: false,
      protocolo: '',
      activeStep: 1,
      directionClass: 'vertical',
      protocoloMask: {
        mask: 'FFFFFF-FFFFFFF-FFFF',
        tokens: {
          F: {
            pattern: /[0-9a-zA-Z]/,
            transform: v => v.toLocaleUpperCase()
          }
        }
      }
    }
  },

  async mounted () {
    this.$nextTick(() => {
      // - Necessário para definir a posição de stepper entre vertical e horizontal
      window.addEventListener('resize', this.handleResize)
    })
    this.handleResize()
    if (this.$route.name !== 'autenticidade') {
      this.isEmpty = false
      this.documento = await this.consultaDocumentoError(this.$route.params.protocolo)

      this.$router.push({
        name: 'detalhesConsulta',
        params: {
          protocolo: this.$route.params.protocolo,
          tipoDocumento: this.$route.params.tipoDocumento
        }
      })
      this.activeStep = 2
    } else {
      this.clearDocumento()
    }
  },

  beforeRouteLeave (to, from, next) {
    this.clearDocumento()
    next()
  },

  beforeDestroy: () => {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    isSearch () {
      return this.activeStep === 1
    }
  },

  methods: {
    ...mapActions({
      consultaDocumentoError: 'documentosAutenticaveis/consultaAutenticidadeError',
      clearDocumento: 'documentosAutenticaveis/clearDocumento',
      baixarDocumento: 'documentosAutenticaveis/download'
    }),
    handleResize () {
      setTimeout(() => {
        this.directionClass = window.innerWidth < 992 ? 'horizontal' : 'vertical'
      }, 5)
    },
    isEmptyDocumento () {
      return _.isEmpty(this.documento); // eslint-disable-line
    },
    downloadDoc () {
      this.baixarDocumento(this.documento.id)
    },
    async search () {
      if (this.protocolo === '') {
        return
      }

      this.protocolo = this.protocolo.replace(' ', '')
      try {
        this.documento = await this.consultaDocumentoError(this.protocolo)
      } catch (e) {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.NAO_HA_REGISTROS
        )
        this.$router.push({
          name: 'autenticidade'
        })
        this.isEmpty = true
        return
      }
      this.isEmpty = false
      this.$router.push({
        name: 'detalhesConsulta',
        params: {
          protocolo: this.protocolo,
          tipoDocumento: this.documento.tipoDocumentoAutenticavel.codigo,
          isQrcode: false
        }
      })
      this.activeStep = 2
    },
    clear () {
      this.activeStep = 1
      this.protocolo = ''
      this.clearDocumento()
      this.documento = null
      this.$router.push({
        name: 'autenticidade'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/_variables.scss";
$color-disable: #d0d0d0f7;

#isEmpty {
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  border-radius: 4px;
}

.title {
  color: $color-primary;
}

.btn {
  float: right;
}

.link-download {
  margin-top: 15px;
  color: $color-primary;
  cursor: pointer;
  &:hover {
    color: #33b281;
  }
}

.subtitle {
  font-size: 20px;
  text-align: center;
}

.step {
  flex-basis: 250px !important;
}

.input {
  padding: 0px 75px 0px 75px;
}

.tipo-doc {
  display: inline-block;
  font-size: 20px;
  margin: 0;
  padding: 5px;
}

.dados-doc {
  overflow: auto;
  height: 370px;
  margin: 10px;
}
/deep/ .el-card__header {
  padding: 10px;
}
/deep/ .el-input__suffix {
  top: 7px;
  cursor: pointer;
  &:hover {
    color: $color-primary;
  }
}
.card {
  height: 510px;
  box-shadow: none;
}

.card-top {
  height: 510px;
  box-shadow: none;
}

/deep/ .el-steps.el-steps--vertical {
  padding-top: 100px;
}

/deep/ .el-step__icon.is-text {
  border: none;
}

/deep/ .el-step__head.is-process {
  color: $color-disable;
  border-color: $color-disable;
}

/deep/ .el-step__head {
  margin-left: 40px;
}

/deep/ .el-step__title.is-process {
  color: $color-disable;
  font-weight: normal;
}

/deep/ .el-step__line {
  background-color: $color-disable;
}

.icon {
  font-size: 45px;
}

@media screen and (max-width: 1129px) {
  /deep/ .el-step__head {
    margin-left: 20px;
  }
}

@media screen and (max-width: 991px) {
  .step {
    flex-basis: 100% !important;
  }
  .el-steps.el-steps--horizontal {
    padding: 0 10% 0 10%;
  }
  .card-steper {
    height: auto;
    margin-bottom: 10px;
  }
  .input {
    padding: 0;
  }
  .icon {
    font-size: 40px;
  }
  .card {
    height: fit-content;
  }
  .dados-doc {
    height: fit-content;
  }
  /deep/ .el-step__title {
    font-size: 14px;
  }
}
@media screen and (max-width: 430px) {
  .subtitle {
    font-size: 16px;
  }
  .tipo-doc {
    font-size: 16px;
  }
  .el-steps.el-steps--horizontal {
    padding: 0 5% 0 5%;
  }
  .btn {
    margin-top: 15px;
  }
}

@media screen and (max-width: 767px) {
  .tipo-doc {
    display: block;
  }

  .btn {
    float: left;
  }

  .link-download {
    float: left;
  }

  /deep/ .el-card__header {
    padding: 10px 10px 70px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/ConsultaAutenticidade.vue